import type { ButtonName } from '@coursera/event-pulse-types';

export type TranslationButtonName = Extract<ButtonName, 'translation_translate' | 'translation_show_original'>;

export const TranslationButtonNames = {
  TRANSLATION_TRANSLATE: 'translation_translate' as TranslationButtonName,
  TRANSLATION_SHOW_ORIGINAL: 'translation_show_original' as TranslationButtonName,
} as const;
